import React from 'react'
import { AppSvg, FormattedHTMLMessage, icons, Button } from '@web/walter-ui-kit'
import { useAuth } from '@web/walter-lib/auth'
import { useIntl } from 'react-intl'

import styles from '../../style.module.css'
import localStyles from './style.module.css'
import { lang } from './lang'
import ModalView from '~components/ModalView'
import { globalLang } from '~globalLang'

function Rejected() {
    const { logout, isLogoutLoading } = useAuth()
    const intl = useIntl()
    const supportLink = intl.formatMessage(globalLang.contactSupportLink)

    return (
        <ModalView
            img={
                <div className={localStyles.icon}>
                    <AppSvg size={60} svgName={icons.ic60CircleExclamation} />
                </div>
            }
            title={<FormattedHTMLMessage {...lang.verificationRejectedTitle} />}
            subtitle={<FormattedHTMLMessage {...lang.verificationRejectedSubtitle} />}
        >
            <div className={styles.mainActionButton}>
                <Button
                    size="l"
                    fullWidth
                    role="anchor"
                    mode="primary"
                    href={supportLink}
                    isDisabled={isLogoutLoading}
                    onClick={e => e.stopPropagation()}
                    dataPointer="support_link_button"
                >
                    <FormattedHTMLMessage {...lang.supportButtonText} />
                </Button>
            </div>
            <Button
                size="l"
                fullWidth={false}
                onClick={() => logout()}
                isLoading={isLogoutLoading}
                dataPointer="sign_out_button"
            >
                <FormattedHTMLMessage {...lang.signOutButtonText} />
            </Button>
        </ModalView>
    )
}

export default Rejected
